import React, { useEffect } from 'react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import './Navbar.css';
import logo from '../assets/images/fintechsmart_Logo.png';
import { BrandLogo } from './FintechSmartSolutions';

const Navbar = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // Close navbar on route change
  useEffect(() => {
    const nav = document.getElementById('navbarNav');
    const toggler = document.querySelector('.navbar-toggler');
    if (nav?.classList.contains('show')) toggler?.click();
  }, [location]);

  // Close navbar on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      const nav = document.getElementById('navbarNav');
      const toggler = document.querySelector('.navbar-toggler');
      if (nav?.classList.contains('show') && !nav.contains(e.target) && !toggler.contains(e.target)) {
        toggler?.click();
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, []);

  // Scroll helper
  const handleScrollToSection = (id) => {
    if (location.pathname !== '/') {
      // Navigate to home page first
      navigate('/', { replace: false });
      setTimeout(() => {
        const section = document.getElementById(id);
        if (section) section.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 150); // delay for DOM render
    } else {
      // Already on home page
      const section = document.getElementById(id);
      if (section) section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <header className="dwl-sticky-wrapper">
      <nav className="navbar navbar-expand-lg dwl-navbar-custom">
        <div className="container">
          <NavLink className="navbar-brand dwl-navbar-brand" to="/">
            <BrandLogo src={logo} alt="Fintech Smart Solutions Logo" />
          </NavLink>

          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse justify-content-end" id="navbarNav">
            <ul className="navbar-nav dwl-nav-list">
              <li className="nav-item dwl-nav-item">
                <NavLink to="/" className="dwl-nav-link" end>
                  Home
                </NavLink>
              </li>
              <li className="nav-item dwl-nav-item">
                <NavLink to="/about-us" className="dwl-nav-link">
                  About Us
                </NavLink>
              </li>
              <li className="nav-item dwl-nav-item">
                <span
                  className="dwl-nav-link"
                  style={{ cursor: 'pointer' }}
                  onClick={() => handleScrollToSection('our-services')}
                >
                  Our Services
                </span>
              </li>
              <li className="nav-item dwl-nav-item">
                <span
                  className="dwl-nav-link"
                  style={{ cursor: 'pointer' }}
                  onClick={() => handleScrollToSection('why-choose-us')}
                >
                  Why Choose Us
                </span>
              </li>
              <li className="nav-item dwl-nav-item">
                <NavLink to="/contact-us" className="dwl-nav-link">
                  Contact Us
                </NavLink>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Navbar;
